import i18n from '@/i18n'; /*
 * @Author: TigerLord
 * @Date: 2022-09-22 15:26:54
 * @LastEditTime: 2022-09-27 11:12:22
 * @LastEditors: your name
 * @Description: 功能说明：——
 * @FilePath: /ytzx-console/src/pages/electron/Entity/index.ts
 */
import loadable from '@loadable/component';
//$IMPORT$

export default () => [
  {
    needLogin: true,
    resourceName: i18n.t('Entity-index-1992f2b7687fd07a8-1'),
    routerUrl: '/Entity',
    resourceIcon: 'TeamOutlined',
    type: '0',
    buttons: [],
    noparent: true,
    component: loadable(() => import('./Entity')),
    children: [
      {
        needLogin: true,
        resourceName: i18n.t('Entity-index-1992f2b7687fd07a8-2'),
        routerUrl: '/EntityBindingRecord',
        resourceIcon: '',
        type: '2',
        buttons: [],
        component: loadable(() => import('./EntityBindingRecord')),
      },
      {
        needLogin: true,
        resourceName: i18n.t('Entity-index-1992f2b7687fd07a8-3'),
        routerUrl: '/EntityRefuel',
        resourceIcon: '',
        type: '2',
        buttons: [],
        component: loadable(() => import('./EntityRefuel')),
      },
      //$MORE$
    ],
  },
];
